<div class="mobile-filters-container flex flex-column gap-3">
  <div class="k-input-wrapper">
    <em class="ph ph-magnifying-glass left-icon"></em>
    <input
      type="text"
      pInputText
      #search
    />
  </div>
  <div class="flex-1 list flex flex-column overflow-auto scroll-class">
    @if (selectedFilterType() === "region") {
      @for (item of regions() | stFilterOnName: search.value; track $index) {
        <div class="list-item">
          <p-checkbox
            [(ngModel)]="selectedRegions"
            inputId="region"
            name="region"
            [value]="item"
            (onChange)="onChange()"
            (ngModelChange)="regionsChange($event)"
          />
          <label
            class="webkit-box-one-line label-large-regular"
            for="region"
            >{{ item.name }}</label
          >
        </div>
      }
    } @else if (selectedFilterType() === "location") {
      @for (item of locations() | stFilterOnName: search.value; track $index) {
        <div class="list-item">
          <p-checkbox
            [(ngModel)]="selectedLocations"
            inputId="location"
            name="location"
            [value]="item"
            (onChange)="onChange()"
            (ngModelChange)="locationsChange($event)"
          />
          <label
            class="webkit-box-one-line label-large-regular"
            for="location"
            >{{ item.name }}</label
          >
        </div>
      } @empty {
        <div
          class="webkit-box-one-line text-base text-color-secondary text-center"
        >
          please select regions
        </div>
      }
    }
  </div>
</div>
